import { combineReducers } from 'redux';
import storyReducer from './reducers/storyReducer';
import levelReducer from './reducers/levelReducer';

const store = combineReducers({
  storyReducer,
  levelReducer,
});

export default store;
